/**
 * Get the localized string for the given key.
 * If no string exists for the given key, return the key itself
 * @param key: localization key.
 * @param replacements: replace result {src} with trg for {src: trg}
 * @param prefix: look for string result by key prefix
 * @return the localized string or the given key if no string was found
 */

export function str(key, replacements, prefix) {
  if (!key) {
    return '';
  }
  const fullKey = prefix ? `${prefix}.${key}` : key;
  const strings = getStrings();
  if (strings && !(strings[fullKey] || strings[key])) {
    // TODO: Too mny logs are being dispatched. Don't send logs until we stablize it.
    // logService.warn({
    //     msg: 'missing string for key',
    //     params: {
    //         key,
    //         replacements,
    //         prefix,
    //     },
    //     url: location.href,
    //     tags: 'localization_missing_key',
    // });
  }
  let result = strings && (strings[fullKey] || strings[key]) || key;
  if (replacements) {
    Object.keys(replacements).forEach(replaceKey => {
      result = result.replace(new RegExp(`{${replaceKey}}`, 'g'), replacements[replaceKey]);
    });
  }
  return result;
}
function getStrings() {
  return window.dmStr || window.parent?.dmStr;
}
//# sourceMappingURL=index.js.map